import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { Tooltip as a } from "@base-ui/react/tooltip";
import { cn as p } from "../../lib/utils.js";
function c({
  delay: t = 0,
  ...o
}) {
  return /* @__PURE__ */ e(
    a.Provider,
    {
      "data-slot": "tooltip-provider",
      delay: t,
      ...o
    }
  );
}
function u({ ...t }) {
  return /* @__PURE__ */ e(a.Root, { "data-slot": "tooltip", ...t });
}
function b({ ...t }) {
  return /* @__PURE__ */ e(a.Trigger, { "data-slot": "tooltip-trigger", ...t });
}
function h({
  className: t,
  side: o = "top",
  sideOffset: i = 8,
  align: d = "center",
  alignOffset: n = 0,
  children: r,
  ...s
}) {
  return /* @__PURE__ */ e(a.Portal, { children: /* @__PURE__ */ e(
    a.Positioner,
    {
      align: d,
      alignOffset: n,
      side: o,
      sideOffset: i,
      className: "isolate z-50",
      children: /* @__PURE__ */ l(
        a.Popup,
        {
          "data-slot": "tooltip-content",
          className: p(
            "z-50 inline-flex w-fit max-w-xs origin-(--transform-origin) items-center gap-1.5 rounded-md bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-sm data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
            t
          ),
          ...s,
          children: [
            r,
            /* @__PURE__ */ e(a.Arrow, { className: "z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground data-[side=bottom]:top-1 data-[side=inline-end]:top-1/2! data-[side=inline-end]:-left-1 data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-right-1 data-[side=inline-start]:-translate-y-1/2 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5" })
          ]
        }
      )
    }
  ) });
}
export {
  u as Tooltip,
  h as TooltipContent,
  c as TooltipProvider,
  b as TooltipTrigger
};
//# sourceMappingURL=tooltip.js.map
